import { Theme } from "@material-ui/core";
import { CSSProperties } from "react";

const PROFILE_SURFACE_GRADIENT = "linear-gradient(180deg, #f9faff 0%, #f6f8ff 100%)";

function profileSurface(theme: Theme): CSSProperties {
  const isDark = theme.palette.type === "dark";

  return {
    position: "relative",
    overflow: "hidden",
    backgroundColor: isDark ? theme.palette.grey[900] : "#f9faff",
    backgroundImage: isDark
      ? `linear-gradient(180deg, ${theme.palette.grey[800]} 0%, ${theme.palette.grey[900]} 100%)`
      : PROFILE_SURFACE_GRADIENT,
    boxShadow: isDark
      ? "inset 0 1px 0 rgba(148, 163, 184, 0.08)"
      : "inset 0 1px 0 rgba(255, 255, 255, 0.85)",
  };
}

/** Profile feature cards (RHI, Stripe payment). */
export function profileFeatureCardSurface(theme: Theme): CSSProperties {
  return profileSurface(theme);
}

/** Profile avatar header band. */
export function profileHeaderCoverSurface(theme: Theme): CSSProperties {
  return profileSurface(theme);
}
